import { MessageCircle } from "lucide-react";

const WA_URL =
    "https://wa.me/573043961777?text=" +
    encodeURIComponent("Hola, AS Consulting. Me gustaría recibir asesoría contable.");

export default function WhatsAppButton() {
    return (
        <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Escríbenos por WhatsApp"
            className="group fixed bottom-6 right-6 z-[70] flex items-center gap-3 rounded-full bg-[#25D366] pl-4 pr-5 py-3.5 text-navy shadow-[0_12px_32px_-8px_rgba(37,211,102,0.6)] transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_-8px_rgba(37,211,102,0.75)] md:bottom-8 md:right-8"
            data-testid="whatsapp-float-button"
        >
            <span className="relative flex h-7 w-7 items-center justify-center">
                <span className="absolute inset-0 animate-ping rounded-full bg-white/50" aria-hidden="true" />
                <MessageCircle size={26} strokeWidth={2} className="relative" />
            </span>
            <span className="hidden text-[11px] font-semibold uppercase tracking-[0.2em] sm:inline">WhatsApp</span>
        </a>
    );
}
